export interface UpgradeModalContent {
  title: string;
  description: string[];
}

export const UPGRADE_MODAL_CONTENTS: Record<string, UpgradeModalContent> = {
  PROJECT_LIMIT: {
    title: '项目数量已达上限',
    description: [
      '您可以删除现有项目以创建新项目，',
      '或者升级到专业版获得无限项目额度'
    ]
  },
  STAGE_LOCKED: {
    title: '阶段未开放',
    description: [
      '您可以按顺序完成前面的阶段，',
      '或者升级到专业版直接解锁此阶段'
    ]
  }
};